<template>
  <div id="ll-signup">
    <ProgrammeSignup
      :title="title"
      :programmeCode="programmeCode"
      :ctaButton="ctaButton"
      :themeColor="themeColor"
      :sale="sale"
      logo="/assets/images/holiday-box-logo.png"
    >
      <template v-slot:sidebar>
        <div class="included mt-5 mt-lg-0">
          <h2>The 1-Year Marvelous Holiday Box includes:</h2>
          <div
            v-for="(included, index) in includedContent"
            :key="index"
            class="smaller py-2"
          >
            <i class="fa fa-check c-coral mr-2"></i>
            <span v-if="included.bonus" class="bonus mr-2">{{
              included.bonus
            }}</span>
            <span>{{ included.description }}</span>
          </div>
        </div>
        <div class="included mt-5">
          <h2>Privacy</h2>
          <p class="smaller mt-3">
            We will not share or trade online information that you provide us
            (including e-mail addresses).
          </p>
          <span>
            <i class="fal fa-user-shield c-coral mr-2"></i>
            <span class="smaller c-dark-gray">Your privacy is protected</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Security</h2>
          <p class="smaller mt-3">
            All personal information you submit is encrypted and secure.
          </p>
          <span>
            <i class="fal fa-lock-alt c-coral mr-2"></i>
            <span class="smaller c-dark-gray">Your information is secure</span>
          </span>
        </div>
        <div class="included mt-5">
          <h2>Need help?</h2>
          <div class="small mt-3">
            Email:
            <a href="mailto:team@heymarvelous.com" class="c-coral"
              >team@heymarvelous.com</a
            >
          </div>
        </div>
      </template>
    </ProgrammeSignup>
  </div>
</template>

<script>
import ProgrammeSignup from '@/web/views/admin/ProgrammeSignup';
export default {
  name: 'MarvelousHolidayBoxProgrammeSignup',
  components: { ProgrammeSignup },
  props: {
    title: {
      type: String,
      default: null,
    },
    programmeCode: {
      type: String,
      default: null,
    },
    ctaButton: {
      type: String,
      default: 'SIGNUP.BUTTON.GET_STARTED',
    },
    themeColor: {
      type: String,
      default: 'lwi',
    },
    sale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    includedContent() {
      return [
        {
          description:
            '1-Year Subscription to Essentials Plan of Marvelous Software (Value $590)',
        },
        {
          description: 'Waiver Template (Value $176)',
        },
        {
          description: 'Membership Crash Course ($93)',
        },
        {
          description: 'New Fan Email Sequence (Value $65)',
        },
        {
          description: 'Gear Guide (Value $20)',
        },
        {
          description: '$20 Gift Card to the Luminous Store',
        },
        {
          bonus: 'TOTAL VALUE',
          description: '$964',
        },
      ];
    },
    marvelousIncludedContent() {
      return [
        {
          description:
            '1-Year Subscription to Essentials Plan of Marvelous Software (Value $590)',
        },
      ];
    },
  },
};
</script>

<style lang="scss">
@import '@/web/styles/components-variables.scss';
@import url('https://fonts.googleapis.com/css2?family=Work+Sans&display=swap');

@font-face {
  font-family: 'ivy_modelight';
  src: url('~@/assets/fonts/ivymode-light-webfont.woff2') format('woff2'),
    url('~@/assets/fonts/ivymode-light-webfont.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

#ll-signup {
  font-family: 'Work Sans', sans-serif;

  h1,
  h2,
  h3 {
    font-family: 'ivy_modelight';
  }

  a {
    color: $coral !important;
  }
}

.included {
  color: $black;
  line-height: 26px;

  h2 {
    color: $dark-gray;
  }

  .bonus {
    text-transform: uppercase;
    color: $coral;
  }
}
</style>
